/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.

// You should NOT make any changes in this file as it will be overwritten.

// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as SportRouteImport } from "./routes/sport";
import { Route as RestaurantRouteImport } from "./routes/restaurant";
import { Route as Privacy_policyRouteImport } from "./routes/privacy_policy";
import { Route as Cookie_policyRouteImport } from "./routes/cookie_policy";
import { Route as ContactRouteImport } from "./routes/contact";
import { Route as AboutRouteImport } from "./routes/about";
import { Route as IndexRouteImport } from "./routes/index";

const SportRoute = SportRouteImport.update({
  id: "/sport",
  path: "/sport",
  getParentRoute: () => rootRouteImport,
} as any);
const RestaurantRoute = RestaurantRouteImport.update({
  id: "/restaurant",
  path: "/restaurant",
  getParentRoute: () => rootRouteImport,
} as any);
const Privacy_policyRoute = Privacy_policyRouteImport.update({
  id: "/privacy_policy",
  path: "/privacy_policy",
  getParentRoute: () => rootRouteImport,
} as any);
const Cookie_policyRoute = Cookie_policyRouteImport.update({
  id: "/cookie_policy",
  path: "/cookie_policy",
  getParentRoute: () => rootRouteImport,
} as any);
const ContactRoute = ContactRouteImport.update({
  id: "/contact",
  path: "/contact",
  getParentRoute: () => rootRouteImport,
} as any);
const AboutRoute = AboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/about": typeof AboutRoute;
  "/contact": typeof ContactRoute;
  "/cookie_policy": typeof Cookie_policyRoute;
  "/privacy_policy": typeof Privacy_policyRoute;
  "/restaurant": typeof RestaurantRoute;
  "/sport": typeof SportRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/about": typeof AboutRoute;
  "/contact": typeof ContactRoute;
  "/cookie_policy": typeof Cookie_policyRoute;
  "/privacy_policy": typeof Privacy_policyRoute;
  "/restaurant": typeof RestaurantRoute;
  "/sport": typeof SportRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/about": typeof AboutRoute;
  "/contact": typeof ContactRoute;
  "/cookie_policy": typeof Cookie_policyRoute;
  "/privacy_policy": typeof Privacy_policyRoute;
  "/restaurant": typeof RestaurantRoute;
  "/sport": typeof SportRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/about"
    | "/contact"
    | "/cookie_policy"
    | "/privacy_policy"
    | "/restaurant"
    | "/sport";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/about"
    | "/contact"
    | "/cookie_policy"
    | "/privacy_policy"
    | "/restaurant"
    | "/sport";
  id:
    | "__root__"
    | "/"
    | "/about"
    | "/contact"
    | "/cookie_policy"
    | "/privacy_policy"
    | "/restaurant"
    | "/sport";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AboutRoute: typeof AboutRoute;
  ContactRoute: typeof ContactRoute;
  Cookie_policyRoute: typeof Cookie_policyRoute;
  Privacy_policyRoute: typeof Privacy_policyRoute;
  RestaurantRoute: typeof RestaurantRoute;
  SportRoute: typeof SportRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/sport": {
      id: "/sport";
      path: "/sport";
      fullPath: "/sport";
      preLoaderRoute: typeof SportRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/restaurant": {
      id: "/restaurant";
      path: "/restaurant";
      fullPath: "/restaurant";
      preLoaderRoute: typeof RestaurantRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/privacy_policy": {
      id: "/privacy_policy";
      path: "/privacy_policy";
      fullPath: "/privacy_policy";
      preLoaderRoute: typeof Privacy_policyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/cookie_policy": {
      id: "/cookie_policy";
      path: "/cookie_policy";
      fullPath: "/cookie_policy";
      preLoaderRoute: typeof Cookie_policyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/contact": {
      id: "/contact";
      path: "/contact";
      fullPath: "/contact";
      preLoaderRoute: typeof ContactRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/about": {
      id: "/about";
      path: "/about";
      fullPath: "/about";
      preLoaderRoute: typeof AboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  Cookie_policyRoute: Cookie_policyRoute,
  Privacy_policyRoute: Privacy_policyRoute,
  RestaurantRoute: RestaurantRoute,
  SportRoute: SportRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
